import React, {useState, useEffect, useContext, useRef} from "react";
import {useParams} from "react-router-dom";
import ListPanel from '../administration/components/ListPanel';
import EditPanel from '../administration/components/EditPanel';
import {useHistory} from 'react-router-dom';
import {store} from '../../context/store';
import {INPUT_TYPE_TEXT} from "../../constants/input-types";
import {INPUT_TYPE_TEXTAREA} from "../../constants/input-types";
import {INPUT_TYPE_SELECT} from "../../constants/input-types";
import {INPUT_TYPE_SELECTFROMDBCONCATENATION} from "../../constants/input-types";
import {functions} from "../../constants/common-functions";
import {TRUE} from "../../constants/general-constants";
import {STRINGIFY} from "../../constants/general-constants";

import {YES_NO_OPTIONS} from "../../constants/general-constants";
import EditButtonPanel from '../administration/components/EditButtonPanel';
import {DEFAULT_BLUE} from "../../constants/general-constants";
import Header from "../../components/Header";
import LeftMenu from "../../components/LeftMenu";

export default function AdministrationResourceDirectoryEdit(){
	
	const globalState = useContext(store);
	const history = useHistory(); 
	const [parentId, setParentId] = useState("0");
	const [entityCode, setEntityCode] = useState("");
	const [entityName, setEntityName] = useState("New Document Type");
	
	
	const refCode = useRef(null);
	const refSystemCode = useRef(null);
	const refName = useRef(null);
	const refDescription = useRef(null);
	
	const id = useParams()["id"];
	
	useEffect(() => {
		loadData();
	}, [id]);
	
	const loadData = () => {
		const timer = setTimeout(() => {
			functions.getObjectFromAjax("/resolutionsoftwareplatform/resourcedirectory?id=" + id, null, initialiseFields);
		}, 100);
	};
	
	const getEntityCode = () => {
		return refCode.current.value;
	};
	
	const getEntityName = () => {
		return refName.current.value;
	};
	
	const initialiseFields = (entity) => {
		console.log(entity);
		const timer = setTimeout(() => {
			try{
				setParentId(entity.parentId);
				setEntityCode(entity.code);
				setEntityName(entity.name);
				
				refCode.current.value = entity.code;
				refName.current.value = entity.name;
			}
			catch(e){}
		}, 100);
	
		
	};
	
	const mainComponentRows = [
		
		{ref:refCode, id:"2", title:"Code", inputType:INPUT_TYPE_TEXT},
		{ref:refName, id:"4", title:"Name", inputType:INPUT_TYPE_TEXT}
	];
	
	const thisContainer = {
		display:"flex",
		width:"calc(100% - 60px)",
		minHeight:"100vh",
		backgroundColor:"white",
		flexDirection:"column",
		//overflow:"auto",
		paddingBottom:"100px",
		marginLeft:"60px",
		marginTop:"60px"
	};
	
	const administrationHeader = {
		display:"flex",
		height:"60px",
		paddingLeft:"20px",
		alignItems:"center",
		color:"black"
	};
	
	const contentPanel = {
		display:"flex",
		width:"100%"
	};
	
	const getSubmitObject = () => {
		
		let submitObject = {
			id:id,
			parentId:parentId,
			code:refCode.current.value,
			name:refName.current.value,
		};
		return submitObject
	}
	
	const goSubmit = () => {
		
		functions.submitAjax("/resolutionsoftwareplatform/resourcedirectorysave", 
				getSubmitObject(), saveEnd,  STRINGIFY, handleSubmitError);
		
	};
	
	const handleSubmitError = (e) => {
		console.log(e);
	};
	
	const saveEnd = () => {
		goCancel();
	};
	
	const goDelete = () => {
		functions.submitAjax("/resolutionsoftwareplatform/resourcedirectorydelete", 
				getSubmitObject(), saveEnd,  STRINGIFY, handleSubmitError);
	};
	
	const goCancel = () => {
		history.goBack();
	};

	return (
		
			<div style={thisContainer}>
				<Header/>
				<LeftMenu/>
				<div style={administrationHeader}>
					Resource Revision Edit: {entityName}
				</div>
				<div style={contentPanel}>
					<EditPanel
					title="Main Details"
						componentRows = {mainComponentRows}
					/>
					
				</div>
				<EditButtonPanel
					id={id}
					goSubmit={goSubmit}
					goDelete={goDelete}
					goCancel={goCancel}
					checkCodeUrl="resourcedirectories"
					getCodeFunction={getEntityCode}
					getNameFunction={getEntityName}
				/>
			</div>
			
	
	);
}